import React, { useContext } from 'react'
import CamIcon from "../image/cam.png"
import AddIcon from "../image/add.png"
import MOreIcon from "../image/more.png"
import Messages from './Messages'
import Input from "./Input"
import { ChatContext } from '../context/ChatContext'

const Chat = () => {

    const { data } = useContext(ChatContext)
    return (
        <div className="chat">
            <div className="chatInfo">
                <span>{data.user?.displayName}</span>
                <div className="chatIcons">
                    <img src={CamIcon} alt="" />
                    <img src={AddIcon} alt="" />
                    <img src={MOreIcon} alt="" />
                </div>
            </div>
            <Messages />
            <Input />
        </div>
    )
}

export default Chat